import { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "utils/redux";

import { setShowAddModal, setCurrentSection } from "reducers/main";
import CreateClaimantModal from "./CreateClaimantModal";
import { SECTION } from "constants/SettingsConstants";

type ClaimantContainerPropTypes = {
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

const ClaimantPageContainer = ({
  header,
  footer,
  children,
}: ClaimantContainerPropTypes) => {
  const dispatch = useDispatch();
  const showAddModal = useSelector((state) => state.main.showAddModal);

  useEffect(() => {
    dispatch(setCurrentSection(SECTION.CLAIMANT));
  }, [dispatch]);

  const modal = useMemo(() => {
    return (
      <CreateClaimantModal
        isOpen={showAddModal}
        onClose={() => {
          dispatch(setShowAddModal(false));
        }}
      />
    );
  }, [showAddModal, dispatch]);

  return (
    <>
      {modal}
      <div className="ClaimantPageContainer">
        {header && (
          <div className="ClaimantPageContainer__Header">{header}</div>
        )}
        <div className="ClaimantPageContainer__Forms">{children}</div>
        {footer && (
          <div className="ClaimantPageContainer__Footer">{footer}</div>
        )}
      </div>
    </>
  );
};

export default ClaimantPageContainer;
